import React from "react"
import {
  Box,
  Grid,
  Typography,
} from "@mui/material";

import { Link, useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";

import { GridContentDashboard } from "../components/CustomGrids";
import AddProjectStepper from "../components/AddProjectStepper";
import { CssBox, CssButton } from "../components/StyledComponent";

import { addCategories } from "../../../store/features/Project";
import CategoryChoice from "../components/CategoryChoice";

const styles = {
  titleInput1: {
    color: "#46bda7",
    fontWeight: "lighter",
  },
  subtitleInput1: {
    fontWeight: "bolder",
    color: "#002f4f",
  },
  cssLink: {
    textDecoration: "none",
  },
  typoMenuLeft1: {
    color: "#002f4f"
  }
};

export default function CategoryChoicePage () {

  const [categories, setCategories] = React.useState([])
  const navigate = useNavigate();
  
  const dispatch = useDispatch()
  

  const handleClickButton = () => {
    dispatch(addCategories(categories))
    navigate("/ajouter-infos-projet", {replace: true});
  }

  return (
    <>
      <Grid container>
        <Grid item paddingTop={4} paddingLeft={2} paddingRight={2} xs={4} md={3} lg={2}>
          <Link to="/dashboard" style={styles.cssLink}>
            <CssBox>
              <Typography variant="subtitle2" style={styles.subtitleInput1}>Mes projets</Typography>
              <Typography variant="body2" style={styles.typoMenuLeft1}>Liste de mes projets</Typography>
            </CssBox>
          </Link>
        </Grid>
        <GridContentDashboard item container direction="column" xs={8} md={9} lg={10}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            marginTop={5}
            marginBottom={10}
          >
            <Box width="20%">
              <AddProjectStepper step={1} />
            </Box>
          </Grid>
          <Grid
            container
            direction="column"
            paddingLeft={5}
            marginTop={5}
            marginBottom={30}
          >
            <Typography variant="h4" style={styles.titleInput1}>
              Categories
            </Typography>
            <Typography variant="body1" style={styles.subtitleInput1}>
              Ajouter des categories a votre projet
            </Typography>
            <Box marginTop={5}>
              <CategoryChoice setCategories={setCategories} />
            </Box>
          </Grid>

          <Grid container direction="row" justifyContent="center">
            <CssButton variant="contained" disabled={categories.length === 0} onClick={() => handleClickButton()}>Continuer</CssButton>
          </Grid>
        </GridContentDashboard>
      </Grid>
    </>
  );
}